import { useEffect } from 'react';

export function useListKeyboardNav<T extends { id: string | number }>(
  items: T[],
  selectedId: string | number | null,
  setSelectedId: (id: string | number) => void,
  options?: { enabled?: boolean }
) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement;
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable
      ) return;
      if (options?.enabled === false) return;
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      e.preventDefault();

      const currentIdx = items.findIndex(i => String(i.id) === String(selectedId));
      let nextIdx = currentIdx;
      if (e.key === 'ArrowDown') {
        nextIdx = currentIdx === -1 ? 0 : Math.min(currentIdx + 1, items.length - 1);
      } else {
        nextIdx = currentIdx <= 0 ? 0 : currentIdx - 1;
      }
      if (nextIdx === currentIdx && currentIdx !== -1) return;

      const nextItem = items[nextIdx];
      if (!nextItem) return;
      setSelectedId(nextItem.id);

      requestAnimationFrame(() => {
        document
          .querySelector(`[data-list-item-id="${nextItem.id}"]`)
          ?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, selectedId, setSelectedId, options?.enabled]);
}
